import { Typography } from '@navi/web-ui/lib/primitives';
import { useEffect, useRef } from 'react';
import { DragFormatTimeForLhBlocking } from './utils';

interface DraggableWarningProps {
  timeLeft: number;
  inCall?: boolean;
}

const DraggableWarning = ({ timeLeft, inCall = false }: DraggableWarningProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      dragElement(containerRef.current, headerRef.current);
    }
  }, []);

  const dragElement = (element: HTMLDivElement, header: HTMLDivElement | null) => {
    let initialX = 0,
      initialY = 0,
      currentX = 0,
      currentY = 0;

    const setInitialPosition = () => {
      const parentHeight = element.parentElement?.clientHeight || window.innerHeight;
      const elementHeight = element.clientHeight;
      const top = (parentHeight - elementHeight) / 2 + 80; //slightly below the center
      const left = 12; //12px to the sidebar
      element.style.position = 'absolute';
      element.style.top = `${top}px`;
      element.style.left = `${left}px`;
    };

    const onMouseDown = (event: MouseEvent) => {
      event.preventDefault();
      currentX = event.clientX;
      currentY = event.clientY;
      document.onmouseup = stopDragging;
      document.onmousemove = onMouseMove;
    };

    const onMouseMove = (event: MouseEvent) => {
      event.preventDefault();
      initialX = currentX - event.clientX;
      initialY = currentY - event.clientY;
      currentX = event.clientX;
      currentY = event.clientY;
      const top = element.offsetTop - initialY;
      const left = element.offsetLeft - initialX;
      element.style.top = `${top}px`;
      element.style.left = `${left}px`;
    };

    const stopDragging = () => {
      document.onmouseup = null;
      document.onmousemove = null;
    };

    if (header) {
      header.onmousedown = onMouseDown;
    } else {
      element.onmousedown = onMouseDown;
    }

    setInitialPosition();
  };

  return (
    <div
      ref={containerRef}
      className="!z-[var(--z-index-block-longhorn-warning)] w-18 absolute bg-[var(--navi-color-red-base)] text-white p-2 rounded-lg shadow-lg cursor-move"
    >
      {inCall ? (
        <Typography variant="h4" color="var(--navi-color-gray-bg-primary)">
          On Call
        </Typography>
      ) : (
        <>
          <Typography variant="h4" color="var(--navi-color-gray-bg-primary)">
            Blocking in
          </Typography>
          <div className="bg-[--navi-color-red-bg] p-1 rounded-lg mt-1 flex items-center justify-center">
            <Typography variant="h2" color="var(--navi-color-red-base)">
              {DragFormatTimeForLhBlocking(timeLeft)}
            </Typography>
          </div>
        </>
      )}
    </div>
  );
};

export default DraggableWarning;
